export default __webpack_public_path__ + "static/media/avatar-placeholder.c6c4f42f.svg";